import { Check } from "lucide-react";
import { STOPS } from "./journey";

const PTS = [[30, 78], [140, 34], [250, 74], [360, 30], [470, 62]];
const path = PTS.map(([x, y], i) => `${i ? "L" : "M"}${x} ${y}`).join(" ");

export function JourneyMap({ completed, current, progress = 0 }) {
  const a = PTS[Math.min(current, 4)];
  const b = PTS[Math.min(current + 1, 4)];
  const t = current >= 4 ? 0 : progress;
  const [mx, my] = current > 4 ? PTS[4] : [a[0] + (b[0] - a[0]) * t, a[1] + (b[1] - a[1]) * t];
  const donePath = PTS.slice(0, Math.min(completed, 4) + 1).map(([x, y], i) => `${i ? "L" : "M"}${x} ${y}`).join(" ");
  return (
    <div className="w-full" data-testid="journey-map">
      <svg viewBox="0 0 500 104" className="w-full h-auto" aria-hidden="true">
        <path d={path} fill="none" stroke="rgba(79,3,65,0.22)" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" strokeDasharray="2 12" />
        {completed > 0 && <path d={donePath} fill="none" stroke="#4F0341" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" />}
        <path d="M455 62 L470 40 L485 62 Z" fill="#F4EBDD" stroke="#4F0341" strokeWidth="1.5" strokeLinejoin="round" opacity={completed >= 5 ? 1 : 0.5} />
        {PTS.map(([x, y], i) => {
          const done = i < completed;
          const now = i === current && !done;
          return (
            <g key={STOPS[i]} data-testid={`journey-stop-${i + 1}`} data-state={done ? "done" : now ? "current" : "ahead"}>
              <circle cx={x} cy={y} r={now ? 13 : 11} fill={done ? "#4F0341" : "#FBF6EF"} stroke={done ? "#4F0341" : now ? "#D9822B" : "#D9CCD6"} strokeWidth="3" style={{ transition: "r 300ms ease" }} />
              {done && <path d={`M${x - 5} ${y} l3.5 3.5 l6.5 -7`} fill="none" stroke="#fff" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" className="stop-check" />}
              {!done && <text x={x} y={y + 4} textAnchor="middle" fontSize="11" fontWeight="700" fill={now ? "#B76A1E" : "#6B5E70"}>{i + 1}</text>}
            </g>
          );
        })}
        {current <= 4 && completed < 5 && (
          <g style={{ transform: `translate(${mx}px, ${my - 22}px)`, transition: "transform 600ms cubic-bezier(0.2, 0.7, 0.2, 1)" }} data-testid="journey-marker">
            <path d="M0 10 C-6 3 -6 -4 0 -6 C6 -4 6 3 0 10 Z" fill="#D9822B" />
            <circle cx="0" cy="-1.5" r="2.4" fill="#fff" />
          </g>
        )}
      </svg>
      <div className="grid grid-cols-5 gap-1 -mt-1">
        {STOPS.map((s, i) => (
          <span key={s} className={`text-center text-[10px] sm:text-xs leading-tight font-semibold ${i < completed ? "text-ds-plum" : i === current ? "text-[#B76A1E]" : "text-ds-inksoft"}`}>
            {i < completed && <Check className="inline h-3 w-3 mr-0.5 -mt-0.5" />}{s}
          </span>
        ))}
      </div>
    </div>
  );
}
